module.exports = __webpack_public_path__ + "img/ivkasirozas.1639f43c.jpg";